const MtrCloseOutline={
    "name": "mtr-close",
    "theme": "outline",
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 24 24"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "fill": "currentColor",
                    "d": "M10.586 12l-6.293 6.293a1 1 0 0 0 1.414 1.414L12 13.414l6.293 6.293a1 1 0 0 0 1.414-1.414L13.414 12l6.293-6.293a1 1 0 1 0-1.414-1.414L12 10.586 5.707 4.293a1 1 0 0 0-1.414 1.414L10.586 12z"
                }
            }
        ]
    }
};
export default MtrCloseOutline;